export const getUniqueId = (prest) => {
    if (!prest.prestId || !prest.prestIdSource || !prest.prestIdFusion) throw new Error("prest must contain prestId, prestIdSource and prestIdFusion")
    return prest.prestId + prest.prestIdSource + prest.prestIdFusion + `${prest.pvFlex || ''}`
  }
  